import React from 'react';
import { TextField } from '@mui/material';
import { acmeTextFieldSx } from '../../theme/acmeTheme';
import { mergeSx } from './utils/mergeSx';

/**
 * shadcn-compatible text input (see Tanplates/input.js).
 */
const Input = React.forwardRef(function Input(
  { sx, size = 'small', variant = 'outlined', fullWidth = true, ...props },
  ref,
) {
  return (
    <TextField
      ref={ref}
      size={size}
      variant={variant}
      fullWidth={fullWidth}
      sx={mergeSx(acmeTextFieldSx, sx)}
      {...props}
    />
  );
});

export default Input;
